<template>
    <div class="home-container">
        <div class="hero-banner">
            <img src="images/banner.webp" alt="" title="" />
            <div class="banner-content">
                <h1 class="animated-title">BRAVESTARCV</h1>
                <!-- <div class="animated-subtitle">
                    <span>{{ lang.vision || '超越视界 各胜其擅 智引未来' }}</span>
                </div>
                <div class="animated-description">
                    <p>{{ lang.description || '布雷斯塔——轻量化、智能化、低成本智能影相视觉方案商' }}</p>
                </div>
                <div class="animated-button">
                    <el-button type="primary" round>{{ lang.viewProducts || '查看产品' }}</el-button>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mixins: [],
    name: "homePage",
    components: {},
    computed: {
        lang() {
            return this.$store.state.language || {};
        }
    },
    data() {
        return {};
    },
    created() {},
    async beforeMount() {},
    mounted() {},
    methods: {
        onSwiper(swiper) {
            console.log(swiper);
        },
        onSlideChange() {
            console.log("slide change");
        },
    },
};
</script>
<style lang="scss">
.home-container {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 0.3s ease;
    background-color: #fff;
    width: 100%;
    height: 100%;
    flex: 1;
    
    .hero-banner {
        width: 100%;
        height: 100%;
        background: #000;
        position: relative;
        overflow: hidden;
        
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            z-index: 1;
        }
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transform: scale(1);
            transition: transform 10s ease;
            animation: subtle-zoom 20s infinite alternate;
        }
        
        .banner-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            z-index: 2;
            width: 80%;
            max-width: 1000px;
            
            .animated-title {
                color: #fff;
                font-size: 72px;
                font-weight: 700;
                letter-spacing: 12px;
                margin-bottom: 20px;
                font-family: 'Arial', sans-serif;
                opacity: 0;
                transform: translateY(-30px);
                animation: fadeInDown 1s ease forwards;
                text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
            }
            
            .animated-subtitle {
                margin-bottom: 20px;
                opacity: 0;
                transform: translateY(-20px);
                animation: fadeInDown 1s ease forwards 0.3s;
                
                span {
                    color: #fff;
                    font-size: 28px;
                    font-weight: 500;
                    letter-spacing: 2px;
                    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
                }
            }
            
            .animated-description {
                margin-bottom: 30px;
                opacity: 0;
                transform: translateY(-10px);
                animation: fadeInDown 1s ease forwards 0.6s;
                
                p {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 18px;
                    line-height: 1.6;
                    max-width: 700px;
                    margin: 0 auto;
                }
            }
            
            .animated-button {
                opacity: 0;
                transform: translateY(10px);
                animation: fadeInUp 1s ease forwards 0.9s;
                
                .el-button {
                    padding: 12px 30px;
                    font-size: 16px;
                    font-weight: 500;
                    border-width: 2px;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
                    }
                }
            }
        }
    }
    
    @keyframes fadeInDown {
        0% {
            opacity: 0;
            transform: translateY(-30px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translateY(30px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @keyframes subtle-zoom {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.1);
        }
    }
    
    @media (max-width: 992px) {
        .hero-banner .banner-content {
            .animated-title {
                font-size: 56px;
                letter-spacing: 8px;
            }
            
            .animated-subtitle span {
                font-size: 24px;
            }
            
            .animated-description p {
                font-size: 16px;
            }
        }
    }
    
    @media (max-width: 768px) {
        .hero-banner .banner-content {
            .animated-title {
                font-size: 42px;
                letter-spacing: 5px;
            }
            
            .animated-subtitle span {
                font-size: 20px;
            }
            
            .animated-description p {
                font-size: 14px;
            }
            
            .animated-button .el-button {
                padding: 10px 24px;
                font-size: 14px;
            }
        }
    }
    
    @media (max-width: 480px) {
        .hero-banner .banner-content {
            width: 90%;
            
            .animated-title {
                font-size: 32px;
                letter-spacing: 3px;
            }
            
            .animated-subtitle span {
                font-size: 18px;
            }
        }
    }
}
</style>
